import { Card } from "../../../../../components/Card";
import { Flex, Icon, Spacer, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { FaExternalLinkAlt } from "react-icons/fa";

function SuitsAgainstCorporations() {
  const suitsList = [
    {
      name: "Financing and investment",
      numberOfLawSuits: 2,
      link: "http://climatecasechart.com/non-us-case-category/financing-and-investment/"
    },
    {
      name: "Pollution",
      numberOfLawSuits: 1,
      link: "http://climatecasechart.com/non-us-case-category/pollution/"
    },
    {
      name: "Climate damage",
      numberOfLawSuits: 17,
      link: "http://climatecasechart.com/non-us-case-category/climate-damage/"
    },
    {
      name: "Just Transition",
      numberOfLawSuits: 1,
      link: "http://climatecasechart.com/non-us-case-category/just-transition-corporations/"
    },
    {
      name: "Carbon credits",
      numberOfLawSuits: 1,
      link: "http://climatecasechart.com/non-us-case-category/carbon-credits/"
    },
    {
      name: "GHG emissions reduction",
      numberOfLawSuits: 27,
      link: "http://climatecasechart.com/non-us-case-category/ghg-emissions-reduction/"
    },
    {
      name: "Misleading advertising",
      numberOfLawSuits: 27,
      link: "http://climatecasechart.com/non-us-case-category/misleading-advertising/"
    },
    {
      name: "Environmental assessment and permitting",
      numberOfLawSuits: 29,
      link: "http://climatecasechart.com/non-us-case-category/environmental-assessment-and-permitting-corporations/"
    },
    {
      name: "Disclosures",
      numberOfLawSuits: 14,
      link: "http://climatecasechart.com/non-us-case-category/disclosures/"
    }
  ];

  return (
    <Card>

      <TableContainer>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th isNumeric>Number of law suits</Th>
            </Tr>
          </Thead>
          <Tbody>
            {suitsList.map((item, index) => {
              return <Tr key={index}>
                <Td>
                  <Text fontWeight="bold">
                    {item.name}
                  </Text>
                </Td>
                <Td isNumeric w="150px">
                  <Flex>
                    <Text fontWeight="bold">{item.numberOfLawSuits}</Text>
                    <Spacer />
                    <a href={item.link} target="_blank" rel="noopener noreferrer">
                      <Icon
                        as={FaExternalLinkAlt}
                        inlineSize="4"
                        blockSize="4"
                      />
                    </a>
                  </Flex>
                </Td>
              </Tr>;
            })}

          </Tbody>
        </Table>
      </TableContainer>
    </Card>
  );
}

export default SuitsAgainstCorporations;